interface CategoryItem {
  name: string;
  url: string;
  imageUrl: string;
  isLarge: boolean;
}

const categoryItems: CategoryItem[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20pairs%20of%20stylish%20sneakers%20in%20white%20grey%20and%20tan%20arranged%20on%20terrazzo%20floor%2C%20bright%20natural%20sunlight%20from%20skylight%2C%20modern%20minimalist%20interior%2C%20editorial%20fashion%20photography%2C%20clean%20composition%2C%20high%20contrast%20shadows&width=600&height=500&seq=grid-shoes-v2&orientation=squarish',
    isLarge: true,
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20charcoal%20grey%20hoodie%20draped%20over%20mid-century%20modern%20wooden%20chair%2C%20morning%20light%20through%20sheer%20curtains%2C%20Scandinavian%20bedroom%20setting%2C%20textured%20fabric%20detail%2C%20lifestyle%20interior%20photography&width=400&height=400&seq=grid-hoodies-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20perfectly%20folded%20pastel%20cotton%20t-shirts%20in%20mint%20peach%20and%20lavender%20on%20white%20marble%20counter%2C%20bright%20clean%20studio%20lighting%2C%20minimalist%20retail%20display%2C%20professional%20garment%20photography&width=400&height=400&seq=grid-tshirts-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Olive%20green%20utility%20jacket%20hanging%20on%20exposed%20brick%20wall%20with%20brass%20hook%2C%20industrial%20loft%20aesthetic%2C%20warm%20edison%20bulb%20glow%2C%20textured%20cotton%20fabric%20visible%2C%20urban%20editorial%20photography&width=400&height=400&seq=grid-jackets-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Well%20tailored%20linen%20trousers%20and%20denim%20shorts%20laid%20flat%20on%20light%20oak%20hardwood%20floor%2C%20sunlight%20shadows%20from%20blinds%2C%20minimalist%20clothing%20photography%2C%20warm%20natural%20textures&width=400&height=400&seq=grid-pants-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20classic%20caps%20in%20sand%20and%20navy%20sitting%20on%20white%20ceramic%20bust%20sculpture%2C%20art%20gallery%20wall%20background%2C%20dramatic%20gallery%20spotlight%2C%20creative%20editorial%20accessory%20photography&width=400&height=400&seq=grid-headwear-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20womens%20blazer%20and%20trousers%20set%20in%20soft%20taupe%20displayed%20on%20minimalist%20metal%20clothing%20rack%2C%20white%20wall%20background%2C%20soft%20studio%20fill%20light%2C%20contemporary%20fashion%20boutique%20style&width=400&height=400&seq=grid-sets-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20organic%20cotton%20underwear%20neatly%20rolled%20in%20drawer%20with%20lavender%20sachet%2C%20light%20wood%20drawer%20interior%2C%20warm%20bedroom%20lighting%2C%20clean%20hygienic%20aesthetic%2C%20lifestyle%20home%20photography&width=400&height=400&seq=grid-underwear-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Basketball%20jersey%20in%20deep%20burgundy%20with%20white%20numbers%20pinned%20on%20cork%20board%20wall%2C%20vintage%20sports%20locker%20room%20vibe%2C%20warm%20overhead%20light%2C%20athletic%20editorial%20photography&width=400&height=400&seq=grid-jersey-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20gold%20tone%20jewelry%20bracelets%20rings%20and%20necklace%20scattered%20on%20dark%20slate%20stone%20surface%2C%20sparkling%20candlelight%20reflections%2C%20luxurious%20jewelry%20display%2C%20rich%20contrast%20photography&width=400&height=400&seq=grid-accessories-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Structured%20leather%20tote%20bag%20in%20cognac%20brown%20placed%20on%20mid-century%20modern%20bench%20with%20green%20plant%20beside%2C%20bright%20entryway%20with%20natural%20light%2C%20lifestyle%20home%20fashion%20photography&width=400&height=400&seq=grid-bags-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20genuine%20leather%20belts%20in%20black%20brown%20and%20tan%20hung%20on%20brass%20wall%20hooks%2C%20boutique%20retail%20display%2C%20warm%20accent%20lighting%2C%20professional%20accessory%20photography%2C%20neat%20organized%20presentation&width=400&height=400&seq=grid-belts-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20artisan%20perfume%20bottles%20with%20amber%20liquid%20on%20dark%20walnut%20wood%20tray%20with%20dried%20flowers%2C%20soft%20backlight%20glow%2C%20luxury%20fragrance%20still%20life%2C%20sophisticated%20apothecary%20aesthetic&width=400&height=400&seq=grid-perfumes-v2&orientation=squarish',
    isLarge: false,
  },
  {
    name: 'OtherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Variety%20of%20fashion%20items%20including%20sunglasses%20wallet%20watch%20and%20keychain%20arranged%20on%20concrete%20surface%2C%20overhead%20flat%20lay%2C%20bright%20even%20lighting%2C%20catalog%20style%20product%20collection%20photography&width=400&height=400&seq=grid-other-v2&orientation=squarish',
    isLarge: false,
  },
];

export default function CategoryGridSection() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
              Product
              <br />
              Categories
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-sm leading-relaxed">
            Browse all mulebuy spreadsheet categories. Each category links directly to verified product listings on the main platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categoryItems.map((cat, index) => {
            const isFirstLarge = index === 0;
            return (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`group relative rounded-xl overflow-hidden cursor-pointer transition-all hover:scale-[1.02] ${
                  isFirstLarge ? 'lg:col-span-2 lg:row-span-2' : ''
                }`}
              >
                <div className={`relative w-full ${isFirstLarge ? 'h-48 md:h-full lg:h-full min-h-[360px]' : 'h-36 md:h-44'}`}>
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} mulebuy spreadsheet category`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                    <h3 className="text-white text-sm md:text-base font-semibold whitespace-nowrap">
                      {cat.name}
                    </h3>
                    <div className="flex items-center gap-1 mt-1.5">
                      <span className="text-white/70 text-xs whitespace-nowrap">View Products</span>
                      <i className="ri-arrow-right-line text-white/70 text-xs group-hover:translate-x-0.5 transition-transform"></i>
                    </div>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}